export default Object.assign(
  theme => {
    return {
      container: {
        padding: 25
      },
      paper: {
        width: 800,
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/adminView/AdminMetadataManager/Search.js